import React, { Component } from 'react';

class FormattedPrice extends Component {
    constructor(props) {
        super(props);
    }

    formatPrice() {
        let formattedPrice =
            this.props.fromPrice == null
                ? this.roundPrice(this.props.price)
                : this.roundPrice(this.props.fromPrice);

        if (!formattedPrice) {
            return 'FREE';
        } else {
            return '€' + formattedPrice;
        }
    }

    roundPrice(price) {
        if (price % 1 === 0) {
            return price;
        } else {
            return price.toFixed(2);
        }
    }

    render() {
        return (
            <p className={'eir-formatted-price ' + this.props.className}>
                {this.props.label && (
                    <small className='text-black text-uppercase mr-2'>
                        <strong>{this.props.label}</strong>
                    </small>
                )}

                <h4 className='d-inline-block'>
                    <strong className='device-price'>
                        {this.props.fromPrice != null && (
                            <small className='mr-2 font19'>From</small>
                        )}
                        {this.formatPrice()}
                    </strong>
                </h4>
            </p>
        );
    }
}

export default FormattedPrice;
